export default __webpack_public_path__ + "static/media/template4.41bcda39.png";